module.exports = "/assets/dist/images/iheart.png?baafe6f55c8c457cc058d2b8536e2fd8";